import { Employment } from 'src/app/shared/models/employment.model';

export class EmploymentHistory {
  employmentList: Employment[];
}
